import { ThunkAction } from "redux-thunk";
import * as types from "./types";

export const store = (
  payload: types.storeAction["payload"]
): types.SnackActionTypes => ({
  type: types.store,
  payload,
});

export const remove = (
  payload: types.removeAction["payload"]
): types.SnackActionTypes => ({
  type: types.remove,
  payload,
});

export const create = (
  snack: Omit<types.storeAction["payload"], "id">
): ThunkAction<void, any, any, any> => (dispatcher) => {
  const id = Date.now();
  const timeout = snack.timeout || 3000;

  dispatcher(store({ ...snack, id, timeout }));

  setTimeout(() => dispatcher(remove({ id })), timeout);
};
